export const API = {
  LOGIN: "login/app",
  RESET_PASSWORD: "auth/reset-password",
  VERIFY_OTP: "auth/verify-otp",
  EMPLOYEE: "hrm/employee",
  DEPARTMENT: "hrm/department",
  PROFILE: "user/profile",
  PROFILE_IMAGE: "user/profile-image",
  HRM_PROFILE: "hrm/user/profile",
  PWD_RESET: "hrm/password/reset",
  CURRICULUM_SEARCH: "curriculum/search",
  CURRICULUM: "curriculum",
  CURRICULUM_COURSE: "curriculum/course",
  COURSE_SEARCH: "course/search",
  COURSE: "course",
  COURSE_ALL: "course/all",
  COURSE_SUBJECT: "course/subject",
  SUBJECT_SEARCH: "subject/search",
  SUBJECT: "subject",
  SUBJECT_SYLLABUS: "subject/syllabus",
  GET_ALL_SYLLABUS_BY_SUBJECT: "subject/:subjectId/syllabuses",
  SYLLABUS: "syllabus",
  SYLLABUS_SEARCH: "syllabus/search",
  GENERATE_SYLLABUS: "syllabus/:syllabusId/generate-from-book-index",
  CREATE_UNIT: "syllabus/:syllabusId/units",
  CREATE_SECTION: "syllabus/units/:unitId/sections",
  CREATE_SUB_SECTION: "syllabus/sections/:sectionId/subsections",
  MODIFY_UNIT: "syllabus/units/:unitId",
  MODIFY_SECTION: "syllabus/sections/:sectionId",
  // Study Materials endpoints
  ADD_STUDY_MATERIAL: "syllabus/study-materials",
  ADD_STUDY_MATERIAL_MULTIPLE_FILES: "syllabus/study-materials/multiple-files",
  ADD_FILES_TO_STUDY_MATERIAL: "syllabus/study-materials/:id/multiple-files",
  REMOVE_FILE_FROM_STUDY_MATERIAL: "syllabus/study-materials/files/:fileId",
  GET_SYLLABUS_STUDY_MATERIALS: "syllabus/:syllabusId/study-materials",
  GET_UNIT_STUDY_MATERIALS: "syllabus/units/:unitId/study-materials",
  GET_SECTION_STUDY_MATERIALS: "syllabus/sections/:sectionId/study-materials",
  GET_STUDY_MATERIAL: "syllabus/study-materials/:id",
  UPDATE_STUDY_MATERIAL: "syllabus/study-materials/:id",
  DELETE_STUDY_MATERIAL: "syllabus/study-materials/:id",
  ADD_FILE_TO_STUDY_MATERIAL: "syllabus/study-materials/:id/files",
  GET_UPLOAD_URL_STUDY_MATERIAL: "syllabus/study-materials/presigned-url",
  CONFIRM_UPLOAD_URL_STUDY_MATERIAL: "syllabus/study-materials/confirm-upload",
  UPDATE_STUDY_MATERIAL_DISPLAY_ORDER: "syllabus/study-materials/display-order",

  ADD_FILES: "files/upload/multiple",
  FILES: "files/:fileId",
  FILE_DOWNLOAD: "files/proxy/:fileId",

  CLASS_SUBJECT: "hrm/class-subjects",
  PROMOTE_STUDENTS: "hrm/student/promote",
  CLASS: "hrm/batch",
  CURRICULUM_360: "curriculum/360",
  STUDENTS: "hrm/students",
  STUDENT: "hrm/student",
  DESIGNATION: "hrm/designation",
  TIMETABLE: "hrm/timetable",
  FACULTY_TIMETABLE: "hrm/faculty/:employeeId/timetable?includeOnlineClassInfo=false",
  CALENDAR: "hrm/calendar",
  LEAVES: "hrm/leave",
  ASSESSMENT: "assessment",
  ASSESSMENT_QUESTION: "assessment/:assessmentId/questions",
  ASSESSMENT_COURSES: "assessment/courses",
  ASSESSMENT_STATS: "assessment/statsCard",
  GET_SUBJECTS_FOR_ASSESSNMENT: "assessment/:assessmentId/subjects",
  ADD_ASSESSMENT_COURSES: "assessment/addToCourseSubject",
  ASSESSMENT_GEN_ANS_KEY: "assessment/:assessmentId/export/answer-key",
  ASSESSMENT_EXPORT: "assessment/:assessmentId/export/question-paper",
  ASSESSMENT_IMPORT : "assessment/:assessmentId/import/questions",
  ASSESSMENT_IMPORT_TEMPLATE:"assessment/import-template/url",
  ASSESSMENT_DOWNLOAD_TEMPLATES: 'assessment/exam-templates',
  ASSESSMENT_TEMPLATE_DETAILS: "assessment/:assessmentId/exam-templates/:templateName",
  AI_ASSESSMENT: "ai-assessment",
  GENERATE_AI_ASSESSMENT: "ai-assessment/generate",
  PROILE_IMG: "hrm/user/profile-image",
  PASSWORD: "user/password",
  ACADEMIC_LENS: "curriculum/lens",
  ROLES: "user/roles",
  ROLE: "user/role",
  USER_ACCT: "user/account",
  USER_ROLES: "user/{id}/roles",
  USER_ACCESS: "user/roles/permissions/tree",
  START_CHAT_SESSION: "chat/start",
  ASK_QUESTION: "chat/ask-ai",
  CLOSE_CHAT_SESSION: "chat/end",
  NOTIFICATION_UNREAD: "notifications/app/unread",
  NOTIFICATION_ACK: "notifications/acknowledge",
  REFRESH_TOKEN: "auth/refresh",
  CREATE_SUPPORT_TICKET: "support/ticket",
  UPDATE_SUPPORT_TICKET: "support/ticket",
  GET_SUPPORT_TICKETS: "support/tickets",
  GET_SUPPORT_TICKET_DETAILS: "support/ticket/:ticketId",
  ADD_TICKET_CONVERSATION: "support/ticket/:ticketId/conversation",
  IMPORT_RESOURCES: "resources/import",
  VALIDATE_RESOURCES: "resources/validate",
  GET_ONBOARDING_TEMPLATE_URL: "resources/onboarding-template",
  ADMIN_DASHBORD: "dashboard/admin",
  SETTINGS_AI_FEATURE_LIMITS: "ai/features/token-limits",
  SETTINGS_AI_FEATURE_ALLOCATION: "ai/features/:featureId/token-allocation/summary",
  SETTINGS_AI_ROLE_LIMITS: "ai/roles/token-limits",
  SETTINGS_AI_ROLE_LIMIT_UPDATE: "ai/token-limits",
  SETTINGS_AI_TOKEN_TOPUP: "ai/token-topups",
  SETTINGS_AI_TOKEN_TOPUP_HISTORY: "ai/features/:featureId/token-topups",
  SETTINGS_AI_TOKEN_USAGE: "ai/features/:featureId/roles/:roleId/token-usage",
  AI_FEATURE_USER_COUNT: "ai/features/:featureId/user-count-by-role",
  AI_FEATURE_COST_ESTIMATE: "ai/features/:featureId/token/cost-calculator",
  SETTINGS_CLOUD_STORAGE_CONFIGS: "tenants/:tenantId/cloud-storage/configs",
  TERMS_AND_CONDITIONS_STATUS: "user-consents/TERMS_AND_CONDITIONS/status",
  TERMS_AND_CONDITIONS : `legal-documents/TERMS_AND_CONDITIONS/latest`,
  REGISTER_CONSENT: "user-consents",
  BATCH_TIMETABLE_PERIODS: "hrm/timetable/course-batch/:batchId",
  ATTENDANCE: "attendance/filter",
  ATTENDANCE_UPDATE: "attendance/student",
  ATTENDANCE_BATCH_REPORT: "attendance/analytics/batch/:batchId/overview",
  SETTINGS_ALL: "settings/all",
  SETTINGS_UPDATE: "settings/save",
  SETTINGS_UPDATE_ALL: "settings/save-all",
  STORAGE_ANALYTICS: "storage/analytics/summary",
  SUBSCRIPTION_PLAN: "subscription-plan",
  SETTINGS_COURSE_CATEGORIES: "course/category",
  USER_SUBSCRIPTION_ACTIVATE : "subscription-plan/:subscriptionPlanId/users/:userId/activate",
  USER_SUBSCRIPTION_DEACTIVATE : "subscription-plan/:subscriptionPlanId/users/:userId/cancel",
  USER_SUBSCRIPTION_ENROLL_ACTIVATE : "subscription-plan/users/:userId/enrollments/:enrollementId/activate",
  USER_SUBSCRIPTION_ENROLL_DEACTIVATE : "subscription-plan/users/:userId/enrollments/:enrollementId/cancel",
  USER_SUBSCRIPTION_ENROLL : "subscription-plan/:subscriptionPlanId/users/:userId/enroll",
  COMMERCIAL_COURSE_REIVEW: "subscription-plan/courses/:courseId/rating?showHiddenReviews=true",
  COMMERCIAL_COURSE_REVIEW_VISIBILITY: "commercial-course/reviews/:reviewId/visibility/toggle",
  PURCHASE_TRANSACTION: "payments/transactions/details"
};

export const AI_FEATURES_ID = {
  CHAT_ASSISTANT: "AI_CA_001",
  ASSESSMENT_GENERATOR : "AI_AG_001",
  SYLLABUS_GENERATOR: "AI_SG_001",
}

export const CURRICULUM_TYPE = [
  { value: "Select", label: "Select" },
  { value: "SEMESTER", label: "Semester" },
  { value: "YEAR", label: "Year" },
];

export const COURSE_TYPE = [
  { value: "Select", label: "Select" },
  { value: "ACADEMIC", label: "ACADEMIC" },
  { value: "SPORTS", label: "SPORTS" },
  { value: "SCIENCE", label: "SCIENCE" },
  { value: "MATH", label: "MATH" },
  { value: "HISTORY", label: "HISTORY" },
  { value: "GEOGRAPHY", label: "GEOGRAPHY" },
  { value: "ACADEMIC", label: "Academic" },
  { value: "PHYSICS", label: "PHYSICS" },
  { value: "CHEMISTRY", label: "CHEMISTRY" },
  { value: "BIOLOGY", label: "BIOLOGY" },
  { value: "ENGLISH", label: "ENGLISH" },
  { value: "ART", label: "ART" },
  { value: "MUSIC", label: "MUSIC" },
  { value: "COMPUTER_SCIENCE", label: "COMPUTER SCIENCE" },
];

export const GENDER = [
  { value: "M", label: "Male" },
  { value: "F", label: "Female" },
  { value: "O", label: "Others" },
];


export const MONTHS_OPTS = [
  {
    value: '01',
    label: "January",
  },
  {
    value: '02',
    label: "February",
  },
  {
    value: '03',
    label: "March",
  },
  {
    value: '04',
    label: "April",
  },
  {
    value: '05',
    label: "May",
  },
  {
    value: '06',
    label: "June",
  },
  {
    value: '07',
    label: "July",
  },
  {
    value: '08',
    label: "August",
  },
  {
    value: '09',
    label: "September",
  },
  {
    value: '10',
    label: "October",
  },
  {
    value: '11',
    label: "November",
  },
  {
    value: '12',
    label: "December",
  }
]

export const SUBSCRIPTION_PLAN_TYPES = [
  { value: "FREE", label: "Free" },
  { value: "DEFAULT", label: "Default" },
  { value: "PREMIUM", label: "Premium" },
];

export const DIFFICULTY_LEVELS = [
  { label: "Beginner", value: "Beginner" },
  { label: "Intermediate", value: "Intermediate" },
  { label: "Advanced", value: "Advanced" }
];


export const GST_STATES =  [
    {
      "label": "Jammu & Kashmir",
      "value": "01"
    },
    {
      "label": "Himachal Pradesh",
      "value": "02"
    },
    {
      "label": "Punjab",
      "value": "03"
    },
    {
      "label": "Chandigarh",
      "value": "04"
    },
    {
      "label": "Uttarakhand",
      "value": "05"
    },
    {
      "label": "Haryana",
      "value": "06"
    },
    {
      "label": "Delhi",
      "value": "07"
    },
    {
      "label": "Rajasthan",
      "value": "08"
    },
    {
      "label": "Uttar Pradesh",
      "value": "09"
    },
    {
      "label": "Bihar",
      "value": "10"
    },
    {
      "label": "Sikkim",
      "value": "11"
    },
    {
      "label": "Arunachal Pradesh",
      "value": "12"
    },
    {
      "label": "Nagaland",
      "value": "13"
    },
    {
      "label": "Manipur",
      "value": "14"
    },
    {
      "label": "Mizoram",
      "value": "15"
    },
    {
      "label": "Tripura",
      "value": "16"
    },
    {
      "label": "Meghalaya",
      "value": "17"
    },
    {
      "label": "Assam",
      "value": "18"
    },
    {
      "label": "West Bengal",
      "value": "19"
    },
    {
      "label": "Jharkhand",
      "value": "20"
    },
    {
      "label": "Odisha",
      "value": "21"
    },
    {
      "label": "Chhattisgarh",
      "value": "22"
    },
    {
      "label": "Madhya Pradesh",
      "value": "23"
    },
    {
      "label": "Gujarat",
      "value": "24"
    },
    {
      "label": "Dadra and Nagar Haveli and Daman and Diu",
      "value": "26"
    },
    {
      "label": "Maharashtra",
      "value": "27"
    },
    {
      "label": "Karnataka",
      "value": "29"
    },
    {
      "label": "Goa",
      "value": "30"
    },
    {
      "label": "Lakshadweep",
      "value": "31"
    },
    {
      "label": "Kerala",
      "value": "32"
    },
    {
      "label": "Tamil Nadu",
      "value": "33"
    },
    {
      "label": "Puducherry",
      "value": "34"
    },
    {
      "label": "Andaman & Nicobar Islands",
      "value": "35"
    },
    {
      "label": "Telangana",
      "value": "36"
    },
    {
      "label": "Andhra Pradesh (New)",
      "value": "37"
    },
    {
      "label": "Ladakh",
      "value": "38"
    },
    {
      "label": "Other Territory",
      "value": "97"
    },
    {
      "label": "Center Jurisdiction",
      "value": "99"
    }
  ]
;  